import React, { useState } from "react";
import { ReactComponent as SearchIcon } from "../../assets/icons/search-sm.svg";
import { ReactComponent as PlusWhiteIcon } from "../../assets/icons/plus-white.svg";
// This component represents the header of the main dashboard.
const tabs = ["Main Dashboard"] as const; // mike t "Real-time Desk", "Custom Tab 1", "+ New Tab" will be added in the future, currently only one tab is available
type DashboardTab = (typeof tabs)[number];

type NewDashboardHeaderProps = {
  onAddGroup?: () => void;
  searchValue?: string;
  onSearchChange?: (value: string) => void;
};

const NewDashboardHeader = ({
  onAddGroup,
  searchValue = "",
  onSearchChange,
}: NewDashboardHeaderProps) => {
  const [activeTab, setActiveTab] = useState<DashboardTab>("Main Dashboard");

  return (
    <div className="rounded-[8px] border border-eai-bg-lt2 bg-white flex flex-col gap-3">
      <div className="flex flex-wrap items-center gap-3 px-3 py-3">
        <div className="relative min-w-[220px] flex-1 w-full sm:w-auto">
          <SearchIcon className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2" />
          <input
            type="text"
            placeholder="Search assets by name, type, or location"
            value={searchValue}
            onChange={(event) => onSearchChange?.(event.target.value)}
            className="h-[32px] w-full rounded-[6px] border border-[#E5E7EB] bg-white pl-10 pr-3 text-[13px] text-[#111928] outline-none placeholder:text-[#9CA3AF] focus:border-[#D1D5DB]"
          />
        </div>
        {/* <button
          type="button"
          className="inline-flex h-[32px] min-w-[106px] items-center justify-between gap-3 rounded-[6px] border border-[#E5E7EB] bg-white px-3 text-xs font-medium text-[#111928]"
        >
          <span>All Status</span>
          <span className="h-2.5 w-2.5 text-[#6B7280]">
            <CaretDownIcon />
          </span>
        </button>

        <button
          type="button"
          className="inline-flex h-[32px] min-w-[132px] items-center gap-2 rounded-[6px] border border-[#E5E7EB] bg-white px-3 text-xs font-medium text-[#111928]"
        >
          <span>2025-10-31&nbsp; 00UTC</span>
          <span className="ml-auto h-3.5 w-3.5 text-[#111928]">
            <CalendarIcon />
          </span>
        </button>

        <button
          type="button"
          className="inline-flex h-[32px] items-center rounded-[6px] border border-[#E5E7EB] bg-white px-3 text-xs font-medium text-[#111928]"
        >
          Compare Assets
        </button> */}

        <button
          type="button"
          onClick={onAddGroup}
          className="inline-flex h-[32px] w-full sm:w-auto justify-center items-center gap-2 rounded-[6px] bg-[#8EA63C] px-4 text-xs font-semibold text-white"
        >
          <span>New Group</span>
          <span className="h-3 w-3">
            <PlusWhiteIcon />
          </span>
        </button>
      </div>

      <div className="px-3">

        <div className="flex items-center gap-1 overflow-x-auto">
          {tabs.map((tab) => {
            const isActive = activeTab === tab;
            return (
              <button
                key={tab}
                type="button"
                onClick={() => setActiveTab(tab)}
                className={`h-[42px] whitespace-nowrap border-b-[2px] px-3 text-[13px] font-medium transition-colors ${
                  isActive
                    ? "border-[#8EA63C] bg-[#F4F7EC] text-[#111928] rounded-t-[12px]"
                    : "border-transparent text-[#6B7280] hover:text-[#374151]"
                }`}
              >
                {tab}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default NewDashboardHeader;
